import useAuth from '../auth/useAuth.js';
import axios from 'axios';
import React, { useState, useLocation, useEffect } from "react";
import { Route, Link} from "react-router-dom";
import { CircularProgress, Button, Typography } from '@material-ui/core';

const NoAccess = ({path }) => {
    let auth = useAuth();
    const login = () => { auth.signin(); }; 

    return (<div>

        {!auth.user ?
            <React.Fragment>               
                  <Typography variant="h1">Log in</Typography>
                <Typography variant="body1" component="p">Please log in to access EO Online.</Typography>
                <Typography variant="body1" component="p">
                    <Button color="primary" component={Link} to={"/ip?origin=" + path} variant="contained" aria-label="open login page">Login</Button>
                    <br /><br />
                    <img src="https://rapid.aaf.edu.au/aaf_service_110x26.png" /></Typography>
                <Typography variant="h1">About</Typography>
                <Typography variant="body1" component="p">EO Online is an equal opportunity professional development program for Australian Universities. This is the third version, completed in 2022.</Typography>
                        <Typography variant="body1" component="p">Every attempt has been made to meet WC3 international accessibility guidelines.</Typography> 
            </React.Fragment>
            : <React.Fragment>
                <Typography variant="h1">No permission to view</Typography>
                <Typography variant="body1" component="p">You do not have access to this area. Insufficient privileges.</Typography>
            </React.Fragment>}
    </div>);
};

function PrivateRoute({ children, component: Component, isStudent, isSuperAdmin, isInstitutionSuperAdmin, isDataDownloadAdmin, isFeedbackAdmin, isRefreshAdmin, hideIfInvalid, location: location,  ...rest }) {
    let auth = useAuth();

    axios.interceptors.response.use(function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        if (401 === error.response.status) {
            auth.signout()
        }

        return Promise.reject(error);
    });

    const canView = () => {
        if (auth.user) {
            if (isStudent && auth.user.isStudent) return true;
            if (isSuperAdmin && auth.user.isSuperAdmin) return true;
            if (isInstitutionSuperAdmin && auth.user.isInstitutionSuperAdmin) return true;
            if (isDataDownloadAdmin && auth.user.isDataDownloadAdmin) return true;
            if (isFeedbackAdmin && auth.user.isFeedbackAdmin) return true;
            if (isRefreshAdmin && auth.user.isRefreshAdmin) return true;

            if (!isStudent && !isSuperAdmin && !isInstitutionSuperAdmin && 
                !isDataDownloadAdmin && !isFeedbackAdmin && !isRefreshAdmin) return true;
        }
        return false;
    };

    const renderInside = () => {
        //all good, display component if it is set (like normal routes can have), or display the children if not
        if (auth.user && canView()) {
            return (Component ? <Component /> : children);
        }


            if (auth.user && canView()) {
                return (Component ? <Component /> : children);
            }
     
        //need login to see
        if (!hideIfInvalid) {
            //but waiting for initial fetch of user data
            if (auth.user == null && !auth.canLogin())
                return <CircularProgress />;
            else {
                return <NoAccess path={location.pathname} />;
            }
        }
        return null;
    };

    return (
        <Route {...rest} render={({ location }) => {
            return (<React.Fragment>
                { renderInside() }
                </React.Fragment>);
            }}
        />
    );
}

export default PrivateRoute;